import styled from 'styled-components'

export const Text = styled.div`
	flex-grow: 1;
`
